module.exports = __webpack_public_path__ + "media/images/photo/plans/places/kobe_ha_ba_land-eff33cb84e8a85f215a99eff16482e2d.png";